import { color } from '../../../resources';
import {
  createColumnDate,
  createColumnNumber,
  createColumnText,
  createColumnTag,
  widthOptions,
} from '../../../components/table/function';

const CAMPAIGN_STATUS = [
  { key: 'USED', value: 'USED', label: 'ใช้สิทธิ์แล้ว', color: color.green },
  { key: 'ACTIVE', value: 'ACTIVE', label: 'พร้อมใช้งาน', color: color.blue },
  { key: 'EXPIRED', value: 'EXPIRED', label: 'หมดอายุ', color: color.red },
];

export const columns = () => {
  return [
    createColumnNumber('ลำดับ', 'rowNumber', widthOptions(80)),
    createColumnText('Partner', 'partnerName', widthOptions(120)),
    createColumnText('ชื่อ Campaign', 'campaignName', widthOptions(180)),
    createColumnText('รหัสคูปอง', 'rawCode', widthOptions(120)),
    createColumnTag(
      'สถานะ',
      { key: 'campaignPoolStatus', text: 'campaignPoolStatusName' },
      CAMPAIGN_STATUS,
      widthOptions(120),
    ),
    createColumnText('ชื่อ-นามสกุล', 'fullName', widthOptions(150)),
    createColumnText('เบอร์โทร', 'telephone', widthOptions(120)),
    createColumnText('รหัสลงทะเบียน', 'warrantyCode', widthOptions(130)),
    createColumnDate('วันที่หมดอายุ', 'expiredDate', widthOptions(150)),
    createColumnDate('วันที่ใช้สิทธิ์', 'usedDate', widthOptions(150)),
  ];
};
